<template>
	<div class="page">
		<el-card>
			<div slot="header" class="card-header">
				<span>敏感词管理</span>
				<div class="header-tools">
					<el-input v-model="filterText" placeholder="筛选敏感词" size="small" clearable
						style="width:180px" prefix-icon="el-icon-search"></el-input>
					<el-popover placement="bottom" width="320" v-model="addVisible" trigger="click">
						<div>
							<el-input type="textarea" v-model="batchWords" :rows="4"
								placeholder="输入敏感词,支持逗号/空格/换行分隔,可批量添加"></el-input>
							<div style="text-align:right;margin-top:10px">
								<el-button size="mini" @click="addVisible = false">取消</el-button>
								<el-button size="mini" type="primary" @click="addBatch">批量添加</el-button>
							</div>
						</div>
						<el-button slot="reference" type="primary" size="small" icon="el-icon-plus"
							style="margin:0 8px">批量添加</el-button>
					</el-popover>
					<span class="stat">共 {{ list.length }} 个 · 启用 {{ enabledCount }} 个</span>
				</div>
			</div>

			<div class="tags-box" v-loading="loading">
				<template v-if="filteredList.length">
					<el-tag v-for="row in filteredList" :key="row.id" size="medium"
						:type="row.enabled ? '' : 'info'" :closable="true"
						:class="{ disabled: !row.enabled }" class="word-tag"
						@click="toggle(row)" @close="remove(row)">
						{{ row.content }}
						<i class="el-icon-turn-off" v-if="!row.enabled"></i>
					</el-tag>
				</template>
				<el-empty v-else :description="filterText ? '没有匹配的敏感词' : '暂无敏感词,点击右上角批量添加'"
					:image-size="80"></el-empty>
			</div>
			<div class="tags-tip">点击标签切换 启用/停用；点 × 删除；启用中的词将在聊天消息中过滤</div>
		</el-card>
	</div>
</template>

<script>
import AdminApi from '../../api/adminApi.js'

export default {
	data() {
		return {
			loading: false,
			list: [],
			filterText: '',
			batchWords: '',
			addVisible: false
		}
	},
	computed: {
		enabledCount() {
			return this.list.filter(r => r.enabled).length
		},
		filteredList() {
			if (!this.filterText) {
				return this.list
			}
			return this.list.filter(r => r.content.includes(this.filterText))
		}
	},
	created() {
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			new AdminApi().listSensitive().then((rows) => {
				this.list = rows || []
			}).catch(() => {}).finally(() => {
				this.loading = false
			})
		},
		addBatch() {
			const words = this.batchWords.split(/[,，\s;；]+/).map(w => w.trim()).filter(w => w)
			if (!words.length) {
				return this.$message.warning('请输入敏感词')
			}
			const unique = [...new Set(words)]
			this.$confirm('将添加 ' + unique.length + ' 个敏感词,确认？', '提示', { type: 'info' }).then(() => {
				Promise.all(unique.map(w => new AdminApi().addSensitive(w)))
					.then(() => {
						this.$message.success('已添加 ' + unique.length + ' 个敏感词')
						this.batchWords = ''
						this.addVisible = false
						this.load()
					})
					.catch(() => { })
			}).catch(() => { })
		},
		toggle(row) {
			const target = !row.enabled
			new AdminApi().updateSensitive(row.id, null, target).then(() => {
				row.enabled = target
			}).catch(() => {})
		},
		remove(row) {
			this.$confirm('确认删除敏感词『' + row.content + '』？', '警告', { type: 'warning' }).then(() => {
				new AdminApi().deleteSensitive(row.id).then(() => {
					this.list = this.list.filter(r => r.id !== row.id)
					this.$message.success('已删除')
				}).catch(() => {})
			}).catch(() => {})
		}
	}
}
</script>

<style scoped>
.page {
	padding: 4px;
}

.card-header {
	font-weight: 600;
}

.header-tools {
	float: right;
	display: flex;
	align-items: center;
	gap: 8px;
}

.stat {
	font-size: 13px;
	color: #909399;
	font-weight: 400;
}

.tags-box {
	min-height: 200px;
	max-height: 60vh;
	overflow-y: auto;
	padding: 12px 8px 4px;
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	gap: 12px 12px;
}

.word-tag {
	cursor: pointer;
	font-size: 14px;

	&.disabled {
		text-decoration: line-through;
	}
}

.tags-tip {
	margin-top: 16px;
	font-size: 12px;
	color: #909399;
}
</style>
